export type FormValue<T> = {
	value: T | null;
	isValid?: boolean;
};

export function areAllFieldsValid(obj: any): boolean {
	if (typeof obj !== "object" || obj === null) {
		return true;
	}

	for (const key in obj) {
		if (
			Object.prototype.hasOwnProperty.call(obj, key) &&
			typeof obj[key] === "object"
		) {
			const subObj = obj[key];
			if (!("isValid" in subObj)) {
				return false;
			}
			if (subObj.isValid !== true) {
				return false;
			}
		}
	}
	return true;
}
